import { Box } from "@mui/material";

export const AvaFieldWrapper = ({ children, bigWidth }: { children: React.ReactNode; bigWidth: boolean }) => (
  <Box sx={{ width: bigWidth ? "49.1%" : "100%" }}>{children}</Box>
);
